import { type ReactNode } from 'react';
import { Assert } from '@team/assert';
import { StringKit } from '@team/string';

export function hasNode(value: ReactNode) {
  if (Assert.isUndefined(value) || Assert.isNull(value) || value === false) {
    return false;
  }

  if (Assert.isString(value)) {
    return !StringKit.isEmpty(value);
  }

  return true;
}
